import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import DetailsButton from '../../../components/Button/DetailsButton';
import TitleInfo from '../../../components/Text/TitleInfo';

const PackageList = () => {
    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('package-management'));
    const navigate = useNavigate();

    console.log(result);

    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const columns = [
        {
            name: 'Name',
            wrap: true,
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Package Category',
            wrap: true,
            center: 'true',
            selector: (row) => row?.packageCat?.name,
        },
        {
            name: 'Package Price',
            wrap: true,
            width: '150px',
            cell: (row) => <div>{row.price} TK </div>,
        },
        {
            name: 'Package Discount',
            wrap: true,
            width: '150px',
            cell: (row) => <div>{row.package_discount} % </div>,
        },

        {
            name: 'Features',
            wrap: true,
            center: 'true',
            cell: (row) => (
                <div>
                    {row.package_features?.map((item) => (
                        <ul key={item.id}>
                            <li> {item?.name} </li>
                        </ul>
                    ))}
                </div>
            ),
        },

        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Action',
            center: 'true',
            cell: (row) => (
                <div>
                    <DetailsButton
                        onClick={() => {
                            setModalOpen('details');
                            setSelectedItem(row);
                        }}
                    />
                    <EditButton
                        onClick={() => navigate(`/dashboard/website/packages/edit/${row?.id}`)}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // delete function

    const abotUsDeleteHandler = () =>
        request.delete('blogs', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Package List'
            buttonTitle='Add New Package'
            addButtonHandler={() => navigate('/dashboard/website/packages/add')}
        >
            <ReactDataTable columns={columns} data={result} pending={isLoading} />

            {/* delete about us */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={abotUsDeleteHandler}
                />
            )}
        </CardLayout>
    );
};

export default PackageList;
